import { useEffect, useState } from "react";
import api from "../../api/axios";
import Swal from "sweetalert2";
import "../../assets/css/Contact/ContactsCreate.css";
 
import {
  FaUser,
  FaUserTag,
  FaEnvelope,
  FaPhone,
  FaBriefcase,
  FaBuilding,
} from "react-icons/fa";
import { Autocomplete, TextField } from "@mui/material";
 
export default function ContactCreateModal({ onClose, refreshContacts }) {
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    designation: "",
    organization_ids: [],
  });
  const [errors, setErrors] = useState({});
  useEffect(() => {
    fetchOrganizations();
  }, []);
 
  const fetchOrganizations = async () => {
    try {
      const res = await api.get("/organization/");
      setOrganizations(res.data);
    } catch (err) {
      console.error(err);
    }
  };
 
  const handleChange = (e) => {
    const { name, value } = e.target;
 
    setForm({ ...form, [name]: value });
 
    // clear error for that field
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
 
 
 
  //validation
 
  const validate = () => {
    const newErrors = {};
 
    const isBlank = (value) =>  !value || value.trim() === "";
 
    if (isBlank(form.first_name)) {
      console.log(form.first_name)
      newErrors.first_name = "First name cannot be empty";
    }
    
    if (isBlank(form.last_name)) {
      console.log(form.last_name)
      newErrors.last_name = "Last name cannot be empty";
    }
    
    if (isBlank(form.email)) {
      console.log(form.email)
      newErrors.email = "Email cannot be empty";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      newErrors.email = "Enter a valid email";
    }
    
    if (isBlank(form.phone)) {
      console.log(form.phone)
      newErrors.phone = "Phone cannot be empty";
    } else if (!/^[6-9]\d{9}$/.test(form.phone.trim())) {
      newErrors.phone = "Enter a valid 10-digit phone number";
    }
    
    if (isBlank(form.designation)) {
      console.log(form.designation)
      newErrors.designation = "Designation cannot be empty";
    }
    
    console.log(form.organization_ids)
    if (form.organization_ids.length === 0) {
    newErrors.organization_ids =
        "Please select at least one organization";
}
 
    setErrors(newErrors);
 
    return Object.keys(newErrors).length === 0;
  };
 
 
  //submit
 
  const submit = async (e) => {
    e.preventDefault();
 
    if (!validate()) return;
 
    try {
      setLoading(true);
 
    await api.post("/contact/create", form);
 
      await Swal.fire({
        icon: "success",
        title: "Contact Created",
        timer: 1200,
        showConfirmButton: false,
      });
 
      refreshContacts();
      onClose();
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.detail || "Failed to create contact",
      });
    } finally {
      setLoading(false);
    }
  };
 
  return (
  <div className="contact-create__overlay" onClick={onClose}>
    <div
      className="contact-create__card"
      onClick={(e) => e.stopPropagation()}
    >
      {/* HEADER */}
      <div className="contact-create__header">
        <h3 className="contact-create__title">Create Contact</h3>
 
        <button
          type="button"
          className="contact-create__close-btn"
          onClick={onClose}
        >
          ✕
        </button>
      </div>
 
      {/* BODY */}
      <form onSubmit={submit} className="contact-create__body">
        <div className="contact-create__grid">
 
          {/* FIRST NAME */}
          <div className="contact-create__group">
            <label>First Name</label>
            <div className="contact-create__input-wrapper">
              <FaUser className="contact-create__icon" />
              <input
                name="first_name"
                value={form.first_name}
                onChange={handleChange}
                placeholder="John"
              />
            </div>
            {errors.first_name && (
              <small className="contact-create__error">
                {errors.first_name}
              </small>
            )}
          </div>
 
          {/* LAST NAME */}
          <div className="contact-create__group">
            <label>Last Name</label>
            <div className="contact-create__input-wrapper">
              <FaUserTag className="contact-create__icon" />
              <input
                name="last_name"
                value={form.last_name}
                onChange={handleChange}
              />
            </div>
            {errors.last_name && (
              <small className="contact-create__error">
                {errors.last_name}
              </small>
            )}
          </div>
 
          {/* EMAIL */}
          <div className="contact-create__group">
            <label>Email</label>
            <div className="contact-create__input-wrapper">
              <FaEnvelope className="contact-create__icon" />
              <input
                name="email"
                value={form.email}
                onChange={handleChange}
              />
            </div>
            {errors.email && (
              <small className="contact-create__error">
                {errors.email}
              </small>
            )}
          </div>
 
          {/* PHONE */}
          <div className="contact-create__group">
            <label>Phone</label>
            <div className="contact-create__input-wrapper">
              <FaPhone className="contact-create__icon" />
              <input
                name="phone"
                value={form.phone}
                onChange={handleChange}
              />
            </div>
            {errors.phone && (
              <small className="contact-create__error">
                {errors.phone}
              </small>
            )}
          </div>
 
          {/* DESIGNATION */}
          <div className="contact-create__group">
            <label>Designation</label>
            <div className="contact-create__input-wrapper">
              <FaBriefcase className="contact-create__icon" />
              <input
                name="designation"
                value={form.designation}
                onChange={handleChange}
              />
            </div>
            {errors.designation && (
              <small className="contact-create__error">
                {errors.designation}
              </small>
            )}
          </div>
 
          {/* ORGANIZATION */}
<div className="contact-create__group">
  <label>Organization</label>
 
  <div className="contact-create__input-wrapper">
    <FaBuilding className="contact-create__icon" />
 
    <Autocomplete
  multiple
      options={organizations}
      getOptionLabel={(option) => option.name || ""}
      value={organizations.filter((org) =>
    form.organization_ids.includes(org.id)
)}
      onChange={(event, newValue) => {
    setForm((prev) => ({
        ...prev,
        organization_ids: newValue.map((org) => org.id),
    }));

    setErrors((prev) => ({
        ...prev,
        organization_ids: "",
    }));
}}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      sx={{
        width: "100%",
        "& .MuiOutlinedInput-root": {
          height: "42px",
          background: "#f8fafc",
          borderRadius: "10px",
          paddingLeft: "28px",
 
          "& fieldset": {
            borderColor: "#e2e8f0",
          },
 
          "&:hover fieldset": {
            borderColor: "#e2e8f0",
          },
 
          "&.Mui-focused fieldset": {
            borderColor: "#2563eb",
          },
 
          "&.Mui-focused": {
            boxShadow: "0 0 0 4px rgba(37, 99, 235, 0.12)",
            background: "#fff",
          },
        },
 
        "& .MuiAutocomplete-input": {
          fontSize: "14px",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select Organization"
          error={!!errors.organization_ids}
        />
      )}
    />
  </div>
 
 {errors.organization_ids && (
  <small className="contact-create__error">
    {errors.organization_ids}
  </small>
)}
  </div>
 
        </div>
 
        {/* FOOTER */}
        <div className="contact-create__footer">
          <button
            type="button"
            className="contact-create__btn-secondary"
            onClick={onClose}
          >
            Cancel
          </button>
 
          <button
            type="submit"
            disabled={loading}
            className="contact-create__btn-primary"
          >
            {loading ? "Saving..." : "Save Contact"}
          </button>
        </div>
      </form>
    </div>
  </div>
);
}
 